// extracted by mini-css-extract-plugin
module.exports = {"container":"placeholder_container__3INtp","icon":"placeholder_icon__2pdBR"};